module.exports = __webpack_public_path__ + "img/vertical_6_5_8004.df9c0297.png";